import { Box, Typography } from '@mui/material';

/** Figma 11101:36062 — Rapchik Rewards / Redeemed Coupons tab switcher */
const TAB_LABEL_SX = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.8px',
  color: '#fff',
  whiteSpace: 'nowrap',
};

export const MY_REWARDS_TABS = {
  rapchik: 'rapchik',
  redeemed: 'redeemed',
};

export default function MyRewardsTabSwitcher({ value, onChange }) {
  const isRapchik = value === MY_REWARDS_TABS.rapchik;

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: 745,
        mx: 'auto',
        p: '5px',
        borderRadius: '60px',
        bgcolor: '#3d0066',
        boxShadow: 'inset 0 4px 4px rgba(0, 0, 0, 0.25)',
        mb: { xs: 2.5, md: 3 },
      }}
    >
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          top: 3,
          left: 3,
          width: 'calc(50% - 3px)',
          height: 38,
          borderRadius: '100px',
          border: '1px solid #ffc5f7',
          background: 'linear-gradient(270deg, #ff00f2 0%, #822aff 100%)',
          boxShadow:
            'inset 2px 2px 5px rgba(255, 255, 255, 0.35), inset -2px -2px 6px rgba(0, 0, 0, 0.25)',
          transform: isRapchik ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 220ms ease',
        }}
      />

      <Box
        component="button"
        type="button"
        onClick={() => onChange?.(MY_REWARDS_TABS.rapchik)}
        sx={{
          position: 'relative',
          zIndex: 1,
          flex: 1,
          border: 0,
          bgcolor: 'transparent',
          cursor: 'pointer',
          px: 2,
          py: 1,
          borderRadius: '40px',
        }}
      >
        <Typography sx={{ ...TAB_LABEL_SX, textAlign: 'center' }}>Rapchik Rewards</Typography>
      </Box>

      <Box
        component="button"
        type="button"
        onClick={() => onChange?.(MY_REWARDS_TABS.redeemed)}
        sx={{
          position: 'relative',
          zIndex: 1,
          flex: 1,
          border: 0,
          bgcolor: 'transparent',
          cursor: 'pointer',
          px: 2,
          py: 1,
          borderRadius: '40px',
        }}
      >
        <Typography sx={{ ...TAB_LABEL_SX, textAlign: 'center' }}>Redeemed Coupons</Typography>
      </Box>
    </Box>
  );
}
